module.exports = __webpack_public_path__ + "img/login_im_complete.0813454.png";